/**------------------------------------------------------
 * Enum Definitions
 */
export enum EnumAiImageGeneratorModule {
	Research 		= 'research',
	UploadImport 	= 'upload_import',
	UploadUpdate 	= 'upload_update'
}


/**------------------------------------------------------
 * Interface Definitions
 */
export interface IAiEditorStates extends Record<EnumAiImageGeneratorModule, Record<string, any>> {
	[EnumAiImageGeneratorModule.Research] 		: Record<string, any>;
	[EnumAiImageGeneratorModule.UploadImport]	: Record<string, any>;
	[EnumAiImageGeneratorModule.UploadUpdate]	: Record<string, any>;
}


/**------------------------------------------------------
 * Type Definitions
 */
export type TypeAiEditorModule			= IAiEditorStates[keyof IAiEditorStates];
export type TypeAiEditorModuleItemKey 	= keyof IAiEditorStates[keyof IAiEditorStates];
export type TypeAiEditorModuleItem 		= IAiEditorStates[keyof IAiEditorStates][keyof IAiEditorStates[keyof IAiEditorStates]];


/**------------------------------------------------------
 * Default Data
 */
export const INITIAL_AI_IMAGE_GENERATOR_STATE_OBJECT: Partial<IAiEditorStates> = {
	[EnumAiImageGeneratorModule.Research]		: {},
	[EnumAiImageGeneratorModule.UploadImport]	: {},
	[EnumAiImageGeneratorModule.UploadUpdate]	: {}
};
